export class ClaimVoorbereidenEventargs {
    constructor(
        public polisnummer: string,
        public schadedatum: string
    ) {
    }
}
